import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { API_ENDPOINTS } from '../../shared/constants/constants';

export const getOrderGRNApi = createAsyncThunk(
  'order/getOrderGRN',
  async (orderId:any) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getGRNByOrderId
    url = url.replace(":orderId", orderId)
    try {
      const response = await axiosGet(
        url
      );
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return error?.response?.data;
    }
  }
);

export const getGRNById = createAsyncThunk(
  'order/getGRN',
  async (grnId:any) => {
    const { axiosGet } = useCustomAxios();
    let grnUrl = API_ENDPOINTS?.getGRNById;
    grnUrl = grnUrl.replace(":grnId", grnId);
    try {
      // console.log(grnUrl)
      const response = await axiosGet(
        grnUrl
      );
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return error?.response?.data;
    }
  }
);

export const CreateOrderGRNApi = createAsyncThunk(
  'order/createOrderGRN',
  async (reqBody:any) => {
    const { axiosPost } = useCustomAxios();
   
    try {
      const response = await axiosPost(
        API_ENDPOINTS?.createOrderGRN,
        reqBody
      );
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return error?.response?.data;
    }
  }
);

export const EditOrderGRNApi = createAsyncThunk(
  'order/editOrderGRN',
  async ({reqBody, orderId, grnId}: {reqBody: any, orderId?: any, grnId?: any}) => {
    const { axiosPut } = useCustomAxios();
   
    try {
      let response: any = {};
      if(orderId){
        response = await axiosPut(
          `${API_ENDPOINTS.editOrderGRN}/${orderId}`,
          reqBody
        );
      }
      else if(grnId){
        response = await axiosPut(
          `${API_ENDPOINTS.editOrderGRN}/${grnId}`,
          reqBody
        );
      }
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getGrnListApi = createAsyncThunk(
  'geGRNList',
  async (parameter: any) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getGRNList;

    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? '&' : '?'}${key}=${value}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const acknowledgeGRNApi = createAsyncThunk(
  'order/ackGRN',
  async (reqBody:any, {rejectWithValue}) => {
    const grnId = reqBody.grnId, data = reqBody.data;
    const { axiosPost } = useCustomAxios();
    let url = API_ENDPOINTS.ackGRN;
    try {
      const response = await axiosPost(
        url,
        {
          grnId,
          ...data
        }
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data?.message);
    }
  }
);

export const getGrnPdf = createAsyncThunk(
  "buyer/getGrnPdf",
  async (reqBody:any) => {
    const { axiosPost } = useCustomAxios();
    let url = API_ENDPOINTS.getGRNPDF;
   
    try {
      const response = await axiosPost(`${url}`,reqBody);
      const downloadURL = response.data.downloadURL;
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      downloadLink.href = downloadURL;
      downloadLink.download = "grn.pdf";
      downloadLink.target = "_blank";
      downloadLink.click();
      document.body.removeChild(downloadLink);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const createInvoiceAfterGRN = createAsyncThunk(
  'grn/invoice',
  async (reqBody:any, {rejectWithValue}) => {
    const { axiosPost } = useCustomAxios();
    let url = API_ENDPOINTS.invoiceAfterGRN;
    try {
      const response = await axiosPost(
        url,
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);